var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreditsBw(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2234 2.87524H1.77637C1.62373 2.87524 1.5 3.01044 1.5 3.1772V14.5733C1.5 14.7401 1.62373 14.8752 1.77637 14.8752H13.2234C13.376 14.8752 13.4997 14.7401 13.4997 14.5733V3.1772C13.4997 3.01044 13.376 2.87524 13.2234 2.87524Z",
    fill: "white",
    stroke: "#3D4755",
    strokeOpacity: 0.8,
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 11.3623L4.5605 8.16791C4.96822 7.74115 5.62331 7.74478 6.02933 8.17518L8.64798 10.9628L10.0827 9.58441C10.4648 9.21757 11.0431 9.20123 11.4423 9.54991L13.4997 11.3423",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 11.3623L4.5605 8.16791C4.96822 7.74115 5.62331 7.74478 6.02933 8.17518L8.64798 10.9628L10.0827 9.58441C10.4648 9.21757 11.0432 9.20123 11.4423 9.54991L13.4997 11.3423",
    stroke: "#3D4755",
    strokeOpacity: 0.8,
    strokeWidth: 1.13548,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.27313 7.26533C9.8003 7.26533 10.2277 6.8067 10.2277 6.24094C10.2277 5.67519 9.8003 5.21655 9.27313 5.21655C8.74596 5.21655 8.3186 5.67519 8.3186 6.24094C8.3186 6.8067 8.74596 7.26533 9.27313 7.26533Z",
    fill: "white",
    stroke: "#3D4755",
    strokeOpacity: 0.8,
    strokeWidth: 1.13548,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditsBw);
export default __webpack_public_path__ + "static/media/credits_bw.dbe825fc057afbabecddde63ed8c2a1f.svg";
export { ForwardRef as ReactComponent };